import {prop, sortBy} from 'ramda';
import React, {useState} from 'react';

import {translate} from 'iss/strings';
import {useQueryState} from 'iss/hooks/useQueryState';
import {searchQuestions} from 'iss/service/QuestionService';
import {Button, EditButton} from 'iss/widgets/Buttons';
import {FlexItem, FlexRow} from 'iss/widgets/Flex';
import {PagedSearchResults, SearchResultScroller, ShowAllResultsButton, TextSearchBar, formatResultCount} from 'iss/widgets/PagedSearchResults';
import {QuestionList} from 'iss/widgets/QuestionList';
import {BatchOpRunnerDialog} from 'iss/widgets/batchOps/BatchOpRunnerDialog';
import BootstrapSelect from 'iss/widgets/bootstrap/Select';
import addQuestionGroup from 'iss/widgets/batchOps/question/addQuestionGroup';
import removeQuestionGroup from 'iss/widgets/batchOps/question/removeQuestionGroup';

function QuestionListPage() {
  const [search, setSearch] = useQueryState({
    defaults: {query: ""}
  });
  const [selected, setSelected] = useState([]);
  const [currentBatchOp, selectBatchOp] = useState(null);
  const getItems = (search, page, size) => {
    return searchQuestions(search.query, page, size, false);
  };

  return <React.Fragment>
    <h1>
      {translate('questionList.title')}
    </h1>
    <Button id="modify-groups" text={translate('questionList.modifyQuestionGroups')} link="/question-groups" />
    <QuestionSearch search={search} onChange={setSearch}/>
    <PagedSearchResults getItems={getItems} search={search}>
      {(results, resultApi) =>
        <React.Fragment>
          <QuestionResultCount searchResult={results} selectedQuestions={selected} onSelectBatchOp={selectBatchOp} onShowAll={resultApi.loadAllItems} />
          <SearchResultScroller searchResult={results} onLoadMore={resultApi.loadMoreItems}>
            <QuestionSearchResults questions={results.results} selected={selected} onChangeSelected={setSelected}/>
          </SearchResultScroller>
          <BatchOpRunnerDialog operation={currentBatchOp} operationTargets={selected}
            onClose={() => selectBatchOp(null)}
            onOperationDone={() => { selectBatchOp(null); setSelected([]); resultApi.reload(); }}
          />
        </React.Fragment>
      }
    </PagedSearchResults>
  </React.Fragment>;
}

function QuestionSearch({search, onChange}) {
  const {query} = search;
  return <TextSearchBar id="question-search" search={query}
    onChange={(newQuery) => onChange({query: newQuery})} >
  </TextSearchBar>;
}

function QuestionResultCount({searchResult, selectedQuestions, onSelectBatchOp, onShowAll}) {
  return <FlexRow alignItems="center" minHeight="3em">
      <FlexItem flex="none">
        {formatResultCount(searchResult)}
        <ShowAllResultsButton searchResult={searchResult} limit={1000} onShowAll={onShowAll} />
      </FlexItem>
      <FlexItem flex="none" className="form-inline">
        <QuestionToolbar selectedQuestions={selectedQuestions} onChoose={onSelectBatchOp}/>
      </FlexItem>
    </FlexRow>;
}

function QuestionToolbar({selectedQuestions, onChoose}) {
  if (!selectedQuestions.length) return null;

  return <React.Fragment>
    {translate('questionList.editSelected') + " "}
    <QuestionBatchOpChooser onChoose={onChoose} />
  </React.Fragment>;
}

function QuestionSearchResults(props) {
  return <QuestionList {...props} selectable={true} extraColumns={[
    {
      header: translate('common.editOrView'),
      accessor: question =>
      <EditButton className="edit-question" id={"edit-question-"+question.id}
        link={"/questions/"+question.id}
        alt={translate('questionList.editQuestionGroupsTooltip')}
      />
    }
  ]}/>;
}


const batchOps = [
  addQuestionGroup,
  removeQuestionGroup
];

export function QuestionBatchOpChooser({onChoose}) {
  const options = batchOps
    .filter(op => ("canAccess" in op) ? op.canAccess() : true)
    .map((operation) => ({label: translate(operation.title), value: operation}));
  return <BootstrapSelect id="batchopChooser" options={sortBy(prop("label"), options)} onChange={({value}) => onChoose(value)}/>;
}

export default QuestionListPage;



// WEBPACK FOOTER //
// ./modules/issFrontend/pages/QuestionListPage.jsx